import {Box, Stack} from '@mui/material';
import React, {FC, ReactNode} from 'react';
import BreadcrumbCustom from "@ui/breadcrumbCustom/BreadcrumbCustom";
import {IBreadcrumbItem} from "@ui/breadcrumbCustom/types";
import {SxType} from "@baseTypes/sx/sxTypes";
import {sx} from './sx'

interface IProps {
    children: ReactNode,
    label?: string,
    breadcrumbs?: IBreadcrumbItem[],
    sx?: SxType,
}

const PageLayout: FC<IProps> = ({
                                    children,
                                    breadcrumbs,
                                    sx: sxProps = {},
                                }) => {
    return (
        <Stack
            sx={{
                ...sx.root,
                ...sxProps,
            }}
        >
            {breadcrumbs && <BreadcrumbCustom
                breadcrumbs={breadcrumbs}
            />}

            <Box
                sx={sx.content}
            >
                {children}
            </Box>
        </Stack>
    );
};

export default PageLayout;